import graphql from './graphql';

const mutation = /* GraphQL */ `
  mutation DocumentCourse_delete($id: ID!) {
    DocumentCourse_delete(id: $id) {
      value
    }
  }
`;

const DocumentCourseDelete = async id =>
  graphql(mutation, { ...id }).then(
    // eslint-disable-next-line camelcase
    ({ DocumentCourse_delete }) => DocumentCourse_delete
  );

export default DocumentCourseDelete;
